/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Events */
export type ReputationMetricsInitializedEvent = {
  agent: Address;
  timestamp: bigint;
};

export type ReputationMetricsInitializedEventArgs = {
  agent: Address;
  timestamp: number | bigint;
};

export function getReputationMetricsInitializedEventEncoder(): FixedSizeEncoder<ReputationMetricsInitializedEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getReputationMetricsInitializedEventDecoder(): FixedSizeDecoder<ReputationMetricsInitializedEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getReputationMetricsInitializedEventCodec(): FixedSizeCodec<
  ReputationMetricsInitializedEventArgs,
  ReputationMetricsInitializedEvent
> {
  return combineCodec(
    getReputationMetricsInitializedEventEncoder(),
    getReputationMetricsInitializedEventDecoder(),
  );
}
